import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { JVInput } from "../../../shared/JVInput";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputTextarea } from "primereact/inputtextarea";
import { ITenderMast } from "./Tender_Mast";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVDate } from "../../../shared/JVDate";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { ILogin } from "../../../models/Login";

interface Iprops {
  singleData: ITenderMast;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}

const schema = yup.object({
  title: yup.string().required("Title Name is required"),
  contact_Person_ID: yup.number().moreThan(0, "Tender Client is required").required("Tender Client is required"),
  minBidAmnt: yup.string().test("min", "Minimum Bid Amount cannot be negative or text", (value) => !value || Number(value) >= 0),
  tender_Published_Date: yup.date().required("Tender Published Date Required"),
  due_Date: yup.date().required("Due Date is Required").min(yup.ref("tender_Published_Date"), "Due Date must be greater than Tender Published Date"),
  q_A_Date: yup.date().nullable().min(yup.ref("tender_Published_Date"), "Q & A Date cannot be before Published Date").max(yup.ref("due_Date"), "Q & A Date cannot be after Due Date"),
  pre_Proposal_Meeting_Date: yup.date().nullable().min(yup.ref("tender_Published_Date"), "Pre Proposal Meeting Date cannot be before Published Date").max(yup.ref("due_Date"), "Pre Proposal Meeting Date cannot be after Due Date"),
  rfP_Number: yup.string().required("RFP Number is required"),
  description: yup.string().nullable(),
  // tender_Doc_Path: yup.string().required("File is Required"),
});

export const Form = (props: Iprops) => {
  const [loading, setLoading] = useState(false);
  const [tenderDocList, setTenderDocList] = useState<Array<{ id: any; title: string; file: File | any | null }>>([]);
  const [description, setDescription] = useState<string>("");
  const [tendorclientPOC, setTendorclientPOC] = useState<any[]>([]);
  const [clientCategory, setClientCategory] = useState<any[]>([]);
  const [tenderServiceDepartment, setTenderServiceDepartment] = useState<{ id: number; department_Name?: string }[]>([]);
  const [clients, setClients] = useState<any[]>([]);
  const [existingDocs, setExistingDocs] = useState<Array<{ id: number; title: string; doc_Path: string }>>([]);

  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors, isDirty },
  } = useForm<ITenderMast>({
    resolver: yupResolver(schema),
    defaultValues: {
      id: props.singleData?.id ?? undefined,
      contact_Person_ID: 0,
      title: "",
      description: "",
      added_On: null,
      updated_On: null,
      service_Department: 0,
      rfP_Number: "",
    },
    shouldFocusError: false,
  });

  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  let _roles: Array<number> = [];
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  const skipCategoryReset = useRef(false);

  const loadCatCompPOC = async (tenderID: number) => {
    const response = await Fetch("Tender_Mast/getTenderCatClientPOCDetails", "GET", null, `tenderID=${tenderID}`, props.toast);
    if (response) {
      const data: any = await response.json();
      setClients((prev) => (prev = [data.vendor_Company]));
      setTendorclientPOC((prev) => (prev = [data.contact_Person]));
      setValue("client_Category", data?.client_Category);
      setValue("vendor_Company", data?.vendor_Company);
      // setValue("contact_Person_ID", data?.contact_Person?.contact_Person_ID);
    }
  };

  useEffect(() => {
    if (props.open) {
      skipCategoryReset.current = true;
      setDescription((prev) => (prev = props?.singleData?.description ?? ""));
      reset({
        id: props.singleData?.id,
        contact_Person_ID: props.singleData?.contact_Person_ID,
        title: props.singleData?.title || "",
        rfP_Number: props.singleData.rfP_Number || "",
        tender_Published_Date: props.singleData?.tender_Published_Date ? new Date(props.singleData.tender_Published_Date) : null,
        pre_Proposal_Meeting_Date: props.singleData?.pre_Proposal_Meeting_Date ? new Date(props.singleData.pre_Proposal_Meeting_Date) : null,
        q_A_Date: props.singleData?.q_A_Date ? new Date(props.singleData.q_A_Date) : null,
        due_Date: props.singleData?.due_Date ? new Date(props.singleData.due_Date) : null,
        // minBidAmnt: props.singleData?.minBidAmnt,
        service_Department: props.singleData?.service_Department,
      });
      if (props.singleData?.contact_Person_ID !== undefined && props.singleData?.contact_Person_ID !== null && props.singleData?.contact_Person_ID > 0) {
        loadCatCompPOC(props.singleData?.id ?? 0);
      }
      setDescription(props.singleData?.description || "");
      setTenderDocList([]);
      if (props.singleData?.id) {
        loadTenderDocs(props.singleData.id);
      } else {
        setExistingDocs([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open, props.singleData, reset]);

  const loadTendorClientPOC = async (clientId: number) => {
    const response = await Fetch("Tender_Client_Category/GetPocbyClient", "GET", null, `clientId=${clientId}`, props.toast);

    if (response?.ok) {
      const data = await response.json();
      setTendorclientPOC(data);
    }
  };
  const loadTenderDocs = async (tenderID: number) => {
    const response = await Fetch(`Tender_Mast/GetTenderDocuments/${tenderID}`, "GET", null, null, props.toast);
    if (response?.ok) {
      const data: Array<{ id: number; title: string; doc_Path: string }> = await response.json();
      setExistingDocs(data);
    }
  };

  const loadClientCategory = async () => {
    const response = await Fetch("Tender_Client_Category/GetAllTenderClientCategory", "GET", null, null, props.toast);
    if (response?.ok) {
      const data: { id: number; department_Name?: string }[] = await response.json();
      setClientCategory(data);
    }
  };

  const loadRFPServiceDepartment = async () => {
    const response = await Fetch("Tender_Service_Department/GetAllActive", "GET", null, null, props.toast);
    if (response?.ok) {
      const data = await response.json();
      setTenderServiceDepartment(data);
    }
  };

  useEffect(() => {
    loadRFPServiceDepartment();
    loadClientCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      // if (name === "tender_Client_ID") {
      //   if (value.tender_Client_ID !== null && value.tender_Client_ID !== 0) {
      //     loadTendorClientPOC(value.tender_Client_ID ?? 0);
      //     setValue("Contact_Person_ID", 0);
      //   }
      //   else loadTendorClientPOC(0);
      // }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const toLocalDateString = (d: any) => {
    if (!d) return null;
    const date = new Date(d);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  };

  const onSubmit = async (data: any) => {
    if (data.id === undefined || data.id === null || data.id === 0) {
      delete data.id;
    }
    delete data.client_Category_ID;
    delete data.tender_Client_ID;
    delete data.poc_Designation;
    delete data.poc_Department;
    // const isHaveVaules: boolean = tenderDocList.length > 0;
    // const isHavTitleEmpty: boolean = tenderDocList.filter((el) => el.title.trim() === "").length > 0;
    // const isHavFileEmpty: boolean = tenderDocList.filter((el) => el.file === null).length > 0;
    // if (isHaveVaules && ((isHavTitleEmpty === true) || (isHavFileEmpty === true))) {
    //   props.toast.current.show({ severity: "error", summary: "Validation", detail: "Please Enter Each Doc Title and Select a File" });
    //   return;
    // }
    try {
      setLoading(true);

      if (!props.singleData?.id && tenderDocList.length === 0) {
        props.toast.current.show({ severity: "error", summary: "Validation", detail: "Please add at least one document." });
        return;
      }
      if (tenderDocList.length > 0) {
        const isTitleEmpty = tenderDocList.some((doc) => doc.title.trim() === "");
        const isFileEmpty = tenderDocList.some((doc) => !doc.file);

        if (isTitleEmpty || isFileEmpty) {
          props.toast.current.show({ severity: "error", summary: "Validation", detail: "Please enter document title and select a file." });
          return;
        }
      }

      if (!data.contact_Person_ID || data.contact_Person_ID <= 0) {
        props.toast.current.show({ severity: "error", summary: "Validation", detail: "Please select a Tender Client POC" });
        return;
      }

      if (new Date(data.tender_Published_Date || "") > new Date(data.due_Date ?? "")) {
        props.toast.current.show({ severity: "error", summary: "Validation", detail: "Please select a Publish Date can not be greater than Due Date" });
        return;
      }

      delete data.client_Category_ID;
      delete data.tender_Client_ID;

      // const descriptionChanged = description !== (props.singleData?.description ?? "");
      data.description = description;
      data.tender_Published_Date = toLocalDateString(data.tender_Published_Date);
      data.pre_Proposal_Meeting_Date = toLocalDateString(data.pre_Proposal_Meeting_Date);
      data.q_A_Date = toLocalDateString(data.q_A_Date);
      data.due_Date = toLocalDateString(data.due_Date);
      const formData = new FormData();
      formData.append("NewTender", JSON.stringify(data));
      if (tenderDocList.length > 0) {
        tenderDocList
          .map((el) => {
            return { title: el.title, file: el.file };
          })
          .forEach((doc, i) => {
            formData.append(`TenderDocs[${i}].Title`, doc.title);
            if (doc.file) {
              formData.append(`TenderDocs[${i}].File`, doc.file);
            }
          });
      }

      const params = {
        method: props.singleData?.id ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
        },
        body: formData,
      };

      const response = await fetch(`${baseUrl}Tender_Mast/${props.singleData?.id ? "UpdateTender" : "AddTendor"}`, params);

      if (response.ok) {
        props.toast.current.show({ severity: "success", summary: "Success", detail: props.singleData?.id ? "Tender Updated Successfully" : "Tender Added Successfully", life: 3000 });
        setTenderDocList([]);
        props.setReload(!props.reload);
        props.hideDialog();
        reset({});
        setDescription("");
      } else {
        const msg = await response.text();
        props.toast.current.show({ severity: "error", summary: "Error", detail: msg, life: 3000 });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onHide = () => {
    setTenderDocList([]);
    setExistingDocs([]);
    props.hideDialog();
    reset({});
  };
  const descriptionChanged = description !== (props.singleData?.description ?? "");
  const documentChanged = tenderDocList.length > 0;

  const loadClients = async (categoryId: number, query: string) => {
    const response = await Fetch("Tender_Client_Category/GetClientByCategory", "GET", null, `categoryId=${categoryId}&query=${query}`, null);

    if (response?.ok) {
      const data = await response.json();
      setClients(data);
    }
  };
  const selectedCategory = watch("client_Category");

  const completeMethod = (e: { query: string }) => {
    if (selectedCategory && selectedCategory > 0) {
      loadClients(selectedCategory, e.query);
    }
  };

  const selectedClient = watch("vendor_Company") as any;

  useEffect(() => {
    if (selectedClient?.id) {
      loadTendorClientPOC(selectedClient.id);
    } else {
      setTendorclientPOC([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClient]);

  useEffect(() => {
    if (skipCategoryReset.current) {
      skipCategoryReset.current = false;
      return;
    }
    setValue("vendor_Company", null);
    setValue("contact_Person_ID", 0);
    setClients([]);
    setTendorclientPOC([]);
  }, [selectedCategory, setValue]);

  const selectedPOC = watch("contact_Person_ID");

  useEffect(() => {
    const poc = tendorclientPOC.find((p) => p.contact_Person_ID === selectedPOC);
    setValue("poc_Designation", poc?.designation ?? "");
    setValue("poc_Department", poc?.department ?? "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPOC, tendorclientPOC]);

  const fileUploade = async (event: FileUploadHandlerParam) => {
    let newDocList: { id: any; title: string; file: File | any | null }[] = [];
    for (let i = 0; i < event.files.length; i++) {
      if (event.files[i].size > 10 * 1024 * 1024) {
        props.toast.current.show({ severity: "error", content: `${event.files[i].name} Document should be less than 10 MB.` });
        event.options.clear();
      } else {
        const file = event.files[i];
        const newName1 = file.name.split(".");
        newName1.pop();
        const fileName: string = newName1.join(".");
        newDocList.push({ id: crypto.randomUUID(), title: fileName, file: event.files[i] });
      }
    }
    setTenderDocList([...tenderDocList, ...newDocList]);
    event.options.clear();
  };
  const dueDate = watch("due_Date");
  const tenderPublishedDate = watch("tender_Published_Date");

  return (
    <>
      <Dialog maximizable modal visible={props.open} onHide={onHide} header="Add/Edit Request For Proposal " style={{ width: "80rem" }} resizable>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
          <JVDropdown required column={3} label="Client Category" control={control} name="client_Category" options={clientCategory} optionLabel="category_Name" optionValue="id" disabled={!!props.singleData?.id && !(_roles.includes(1) || _roles.includes(26) || _roles.includes(56))} />
          <JVDropdownInput required completeMethod={completeMethod} label="Client" control={control} name="vendor_Company" error={errors.vendor_Company?.message} options={clients} optionLabel="client_Name" placeholder="Search Client Company" disabled={!!props.singleData?.id && !(_roles.includes(1) || _roles.includes(26) || _roles.includes(56))} />
          <JVDropdown required filter column={3} label="Contact Person POC" control={control} name="contact_Person_ID" options={tendorclientPOC} optionLabel="displayName" optionValue="contact_Person_ID" disabled={!!props.singleData?.id && !(_roles.includes(1) || _roles.includes(26) || _roles.includes(56))} />
          {/* <JVInput required column={3} label="Minimum Bid Amount" control={control} name="minBidAmnt" error={errors.minBidAmnt?.message} /> */}
          <JVInput disabled column={3} label="POC Designation" control={control} name="poc_Designation" />
          <JVInput disabled column={3} label="POC Department" control={control} name="poc_Department" />
          <JVDropdown required filter column={3} label="Service Department" control={control} name="service_Department" options={tenderServiceDepartment} optionLabel="department_Name" optionValue="id" disabled={!!props.singleData?.id && !(_roles.includes(1) || _roles.includes(26) || _roles.includes(56))} />
          <JVInput required column={3} label="RFP Number" control={control} name="rfP_Number" error={errors.rfP_Number?.message} disabled={!!props.singleData?.id && !(_roles.includes(1) || _roles.includes(26) || _roles.includes(56))} />
          <JVInput required column={3} label="RFP Title" control={control} name="title" error={errors.title?.message} disabled={!!props.singleData?.id && !(_roles.includes(1) || _roles.includes(26) || _roles.includes(56))} />
          <JVDate required column={3} label="Published Date" control={control} name="tender_Published_Date" maxDate={new Date()} disabled={!!props.singleData?.id && !(_roles.includes(1) || _roles.includes(26) || _roles.includes(56))} />
          <JVDate required column={3} minDate={control?._formValues?.tender_Published_Date || new Date()} label="Due Date" control={control} name="due_Date" />
          <JVDate column={3} label="Pre Proposal Meeting Date" control={control} name="pre_Proposal_Meeting_Date" minDate={tenderPublishedDate ? new Date(tenderPublishedDate) : undefined} maxDate={dueDate ? new Date(dueDate) : undefined} disabled={!tenderPublishedDate || !dueDate} />
          <JVDate column={3} label="Q & A Date" control={control} name="q_A_Date" minDate={tenderPublishedDate ? new Date(tenderPublishedDate) : undefined} maxDate={dueDate ? new Date(dueDate) : undefined} disabled={!tenderPublishedDate || !dueDate} />
          <div className="field col-12">
            <label>Description</label>
            <InputTextarea value={description} onChange={(e) => setDescription(e.target.value)} rows={4} cols={30} className="w-full" placeholder="Enter task description" />
          </div>
          {/* <div className="field col-12 md:col-4">
            <Button type="button" label="Add Document" onClick={() => setTenderDocList([...tenderDocList, { id: crypto.randomUUID(), title: "", file: null }])} />
          </div> */}
          <div className="mt-2 field col-12 md:col-12" style={{ maxHeight: "30rem", overflowY: "scroll" }}>
            {/* {tenderDocList.map((el: { id: any; title: string; file: File | any | null }, index: number) => (
              <TenderMultipleDoc key={index} tenderDocList={tenderDocList} setTenderDocList={setTenderDocList} id={el.id} toast={props.toast} />
            ))} */}
            <div className="p-2 pl-3" style={{ border: "1px solid rgb(210, 208, 208)" }}>
              <span id="file" style={{ width: "15rem" }}>
                RFP Document <span style={{ color: "red" }}>*</span>
              </span>
              <FileUpload multiple chooseLabel={"Choose Documents"} mode="basic" name="file" accept="*" maxFileSize={20 * 1024 * 1024} auto customUpload uploadHandler={fileUploade} />
            </div>
            <div className="p-2 pl-3" style={{ border: "1px solid rgb(210, 208, 208)" }}>
              <div className="flex flex-wrap">
                {existingDocs.map((el) => (
                  <div key={el.id} className="mr-1 p-1 flex align-items-center align-content-center mt-1" style={{ border: "1px solid rgb(210, 208, 208)" }}>
                    <a href={`${baseUrl}${el.doc_Path}`} target="_blank" rel="noreferrer" className="mr-1 p-1">
                      {el.title}
                    </a>
                  </div>
                ))}
                {tenderDocList.map((el) => (
                  <div key={el.id} className="mr-1 p-1 flex align-items-center align-content-center mt-1" style={{ border: "1px solid rgb(210, 208, 208)" }}>
                    <p className="mr-1 p-1">{el.title}</p>
                    <Button icon="pi pi-trash" tooltip="Delete" className="p-button-rounded p-button-text p-button-danger" onClick={() => setTenderDocList((prev) => prev.filter((d) => d.id !== el.id))} />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-12 flex gap-4 justify-content-end">
            <Button style={{ width: "100px" }} label={props.singleData?.id ? "UPDATE" : "SAVE"} type="submit" loading={loading} disabled={!(isDirty || descriptionChanged || documentChanged)} />
            <Button style={{ width: "100px" }} label="CLOSE" type="button" onClick={onHide} className="p-button-outlined" />
          </div>
        </form>
      </Dialog>
    </>
  );
};
